import Web3Modal from "web3modal";

import { getNetworkConnectors} from "../helpers/getNetworkData";
    let a:any = getNetworkConnectors() ;
export const createWeb3Modal:any = () => new Web3Modal(a);
